import { FunctionComponent } from "react";
import { LogoSkeleton } from "@components/layout/logo/logo-skeleton";
import { Skeleton } from "@components/common/skeleton/skeleton";

interface TopbarSkeletonProps {
    expanded: boolean;
}

export const TopbarSkeleton: FunctionComponent<TopbarSkeletonProps> = ({ expanded }) => {
    return (
        <>
            <div>
                <div className="-ml-3 lg:hidden">
                    <LogoSkeleton expanded={expanded} />
                </div>
                <div className="hidden w-96 lg:block">
                    <Skeleton width={250} className="my-2.5 h-5 bg-gray-400" rounded="md" />
                </div>
            </div>
            <div className="ml-auto flex items-center gap-1">
                <div className="flex h-9 w-9 items-center justify-center">
                    <Skeleton className="h-5 w-5 bg-gray-400" rounded="full" />
                </div>
                <div className="flex h-9 w-9 items-center justify-center">
                    <Skeleton className="h-5 w-5 bg-gray-400" rounded="full" />
                </div>
                <div className="flex h-9 w-9 items-center justify-center">
                    <Skeleton className="h-5 w-5 bg-gray-400" rounded="full" />
                </div>
            </div>
        </>
    );
};
